import React from 'react';
import { IconButton, TextField, Button } from '@material-ui/core';

import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';

const EMPTY_CONFIG = { steps: [] };

const cardStyle = {
    position: 'relative',
    border: '1px solid #d8dbe0',
    borderRadius: 6,
    padding: '12px 16px 16px',
    margin: '8px 0',
    background: '#fafbfc'
};

const cardHeaderStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 8
};

const stepBadgeStyle = {
    width: 26,
    height: 26,
    borderRadius: '50%',
    background: '#eaedf1',
    color: '#52596a',
    fontWeight: 700,
    fontSize: 13,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 10
};

const fullWidthField = { width: '100%', marginBottom: 10 };

function parseConfig(raw) {
    if (!raw) return { ...EMPTY_CONFIG };
    try {
        const parsed = JSON.parse(raw);
        return {
            steps: Array.isArray(parsed.steps) ? parsed.steps : []
        };
    } catch (err) {
        console.error('onboardingCompletionConfig parse error:', err);
        return { ...EMPTY_CONFIG };
    }
}

function isEmpty(config) {
    return !config.steps || config.steps.length === 0;
}

export class CompletionConfig extends React.Component {
    constructor(props) {
        super(props);
        this.state = { org: props.org };
    }

    render() {
        const { onChange } = this.props;
        const { org } = this.state;
        const config = parseConfig(org.config['onboardingCompletionConfig']);

        const onUpdateOrg = () => {
            if (isEmpty(config)) {
                delete org.config['onboardingCompletionConfig'];
            } else {
                org.config['onboardingCompletionConfig'] = JSON.stringify(config);
            }
            this.setState({ org }, () => {
                if (onChange) onChange(org);
            });
        };

        return <div style={{ padding: '8px 12px' }}>
            {config.steps.map((step, i) => (
                <div key={`step-${i}`} style={cardStyle}>
                    <div style={cardHeaderStyle}>
                        <span style={{ display: 'flex', alignItems: 'center', fontWeight: 600, color: '#52596a', fontSize: 13 }}>
                            <span style={stepBadgeStyle}>{i + 1}</span>
                            Step {i + 1}
                        </span>
                        <IconButton size='small' onClick={() => {
                            config.steps.splice(i, 1);
                            onUpdateOrg();
                        }}><DeleteIcon fontSize='small' /></IconButton>
                    </div>
                    <TextField style={fullWidthField} label='Title' value={step.title || ''} onChange={(e) => {
                        step.title = e.target.value;
                        onUpdateOrg();
                    }} />
                    <TextField variant='outlined' style={fullWidthField} multiline={true} minRows={2} maxRows={5} label='Detail (optional)' value={step.detail || ''} onChange={(e) => {
                        step.detail = e.target.value;
                        onUpdateOrg();
                    }} />
                    <div style={{ display: 'flex', gap: 12, marginBottom: 10 }}>
                        <TextField style={{ width: 260 }} label='Link title (optional)' value={step.linkTitle || ''} onChange={(e) => {
                            step.linkTitle = e.target.value;
                            onUpdateOrg();
                        }} />
                        <TextField style={{ flex: 1 }} label='Link URL (optional)' value={step.linkUrl || ''} onChange={(e) => {
                            step.linkUrl = e.target.value;
                            onUpdateOrg();
                        }} />
                    </div>
                    <TextField variant='outlined' style={fullWidthField} multiline={true} minRows={2} maxRows={5} label='Warning (optional)' value={step.deferred || ''} onChange={(e) => {
                        step.deferred = e.target.value;
                        onUpdateOrg();
                    }} />
                </div>
            ))}
            <Button size='small' startIcon={<AddIcon />} onClick={() => {
                config.steps.push({ title: '', detail: '', linkTitle: '', linkUrl: '', deferred: '' });
                onUpdateOrg();
            }}>Add step</Button>
        </div>;
    }
}
